import { parseJson } from '@flowio/web-sdk';

const forEach = require('lodash/forEach');
const LocalizedVariantStore = require('./localized-variant-store');
const LocalizedOrderStore = require('./localized-order-store');
const raven = require('../utilities/raven');

const variantStore = new LocalizedVariantStore();
const orderStore = new LocalizedOrderStore();

function buildLocalizedVariantsCache() {
  const localizedVariantDataElements = document.querySelectorAll('[flow-localized-variant]');

  forEach(localizedVariantDataElements, (variantDataElement) => {
    try {
      const value = parseJson(variantDataElement.getAttribute('value'));
      variantStore.addVariant(value);
    } catch (error) {
      raven.captureError(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
  });

  return variantStore;
}

function buildLocalizedOrdersCache() {
  const localizedOrderDataElements = document.querySelectorAll('[flow-localized-order]');

  forEach(localizedOrderDataElements, (orderDataElement) => {
    try {
      const value = parseJson(orderDataElement.getAttribute('value'));
      orderStore.addOrder(value);
    } catch (error) {
      raven.captureError(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
  });

  return orderStore;
}

function buildCache() {
  return {
    localizedVariants: buildLocalizedVariantsCache(),
    localizedOrders: buildLocalizedOrdersCache(),
  };
}

/**
 * Flow.cache is set at runtime. This helper makes it so that there is only
 * one place internal to flow.js that `Flow.cache` is referenced.
 */
function getCache() {
  return window.Flow.cache;
}

module.exports = {
  buildCache,
  buildLocalizedVariantsCache,
  buildLocalizedOrdersCache,
  getCache,
};



// WEBPACK FOOTER //
// ./static/js/v0/cache/index.js